/**
 * ResizeHandle · 拖拽手柄（独立 flex item 版）
 *
 * 对应文档：docs/AI-Photo-Category/TECH_PLAN.md §4.2.2
 *
 * 设计要点：
 *  · 不再 absolute 定位到 AISidebar 左边缘，而是由页面作为独立 flex item 使用
 *  · 手柄图标：1 列 × 6 个 3px 小圆点纵向排布（纯 CSS 实现）
 *  · hover / dragging 时圆点颜色加深
 *  · 整条 6px 命中 `cursor: col-resize`
 *  · 仅转发 onMouseDown，不持有任何状态
 */

import React from 'react'
import classNames from 'classnames'
import styles from './ResizeHandle.module.scss'

/** 手柄圆点数量 · 1 列 × 6 个 */
const DOT_COUNT = 6

interface ResizeHandleProps {
  /** mousedown 事件 · 由外部 useResizable.handleMouseDown 注入 */
  onMouseDown: (e: React.MouseEvent) => void
  /** 是否处于拖拽中 · 控制视觉反馈态 */
  isDragging?: boolean
}

const ResizeHandle: React.FC<ResizeHandleProps> = ({
  onMouseDown,
  isDragging
}) => (
  <div
    className={classNames(styles.handle, {
      [styles.handleDragging]: isDragging
    })}
    onMouseDown={onMouseDown}
    role="separator"
    aria-label="拖拽调整侧边栏宽度"
    aria-orientation="vertical"
  >
    <div className={styles.dots}>
      {Array.from({ length: DOT_COUNT }).map((_, i) => (
        <span key={i} className={styles.dot} />
      ))}
    </div>
  </div>
)

export default ResizeHandle
